<template>
	<div :class="['c-renderer', { moving: moving === true }]" ref="renderer">
		<transition-group name="list" tag="div" class="hook-block-children">
			<Block
				v-for="(blockData, i) in computedBlocks"
				:key="blockData.block._id"
				:blockData="blockData"
				@dragstart="onDragStart"
			>
			</Block>
			<Block
				@createBlock="addTextBlock"
				v-if="currentBlock && !hasTextBlock"
				key="fakeblock"
				:blockData="fakeBlockData"
				:fakeBlock="true"
			>
			</Block>
		</transition-group>
		<Dropcursor ref="dropcursor" @dragend="onDragend"></Dropcursor>
	</div>
</template>

<script>
import DragSelect from '@/components/dashboard/drag-select';
import Block from '@/components/dashboard/block';

import Dropcursor from '@/components/dashboard/dropcursor';

import $ from 'jquery';

import hotkeys from 'hotkeys-js';
import anime from 'animejs';

export default {
	components: {
		DragSelect,
		Block,
		Dropcursor,
	},

	data: function () {
		return {
			active: false,
			dropcursor: {
				lastOffset: 0,
				el: null,
				blockPosition: 0,
				isCentered: false,
				position: 'top',
			},
			block: {
				id: null,
				moving: false,
				x: 0,
				y: 0,
			},
			selected: [],
		};
	},

	props: {
		currentBlock: Object,
	},

	watch: {
		// remove UI effects if present. Cuz they won't be if someone clicks on a folder block and currenblock gets updated
		currentBlock: function () {
			this.selected = [];
			this.$refs.dropcursor.stop();
			this.onPageRender();
		},
		selection: function () {
			if (this.selection.length > 0) {
				window.parent.postMessage({ type: 'selection' }, '*');
			}
		},
		computedBlocks: function () {},
	},

	computed: {
		moving: function () {
			return this.$store.getters['dashboard/moving'];
		},
		selection: function () {
			return this.$store.getters['dashboard/selection'] || [];
		},
		blocks: function () {
			let blocks = this.$store.getters['block/blocks'];
			return blocks;
		},
		currentBlocks: function () {
			let newBlocks = [];
			let blocks = this.blocks;
			let currentBlock = this.currentBlock;
			for (let i = 0; i < blocks.length; i++) {
				if (
					blocks[i].parent === currentBlock._id &&
					blocks[i].archive === false
				) {
					newBlocks.push(blocks[i]);
				}
			}
			return newBlocks;
		},
		fakeBlockData: function () {
			return {
				selected: false,
				block: {
					root: false,
					archive: false,
					type: 'text',
					blocks: [],
					parent: this.currentBlock._id,
					content: {
						html: '',
					},
					source: {},
					_id: '666',
				},
			};
		},
		hasTextBlock: function () {
			let blockDataArray = this.computedBlocks;
			let condition = false;
			for (let i = 0; i < blockDataArray.length; i++) {
				if (blockDataArray[i].block.type === 'text') {
					condition = true;
					break;
				}
			}
			return condition;
		},
		computedBlocks: {
			get() {
				let selection = this.selection;
				let blocks = this.currentBlocks;

				// if empty then break
				if (blocks.length === 0) {
					return [];
				}

				// reordering blocks to match the folder structure
				let newBlocks = [];
				let blocksArray = this.currentBlock.blocks || [];
				for (let i = 0; i < blocksArray.length; i++) {
					for (let j = 0; j < blocks.length; j++) {
						if (blocksArray[i] && blocksArray[i].includes(blocks[j]._id)) {
							newBlocks.push({
								selected: false,
								block: blocks[j],
							});
							break;
						}
					}
				}

				// finally, adding metadata to the blocks
				let finalBlocks = [];
				for (let i = 0; i < newBlocks.length; i++) {
					if (selection.includes(newBlocks[i].block._id)) {
						newBlocks[i].selected = true;
					}
				}

				finalBlocks = newBlocks;

				return finalBlocks;
			},
			set(v) {
				console.log(v);
			},
		},
	},

	methods: {
		onPageRender: function () {
			anime({
				targets: this.$refs.renderer,
				translateX: [10, 0],
				opacity: [0, 1],
				duration: 200,
				easing: 'cubicBezier(0.165, 0.840, 0.440, 1.000)',
			});
		},
		onDragStart: function (id) {
			this.$refs.dropcursor.startDrag(id);
		},
		async onDragend(data) {
			if (data.type === 'swap') {
				await this.$store.dispatch('block/updatePosition', {
					parentBlock: this.currentBlock,
					currentBlock: data.currentBlock,
					replacerBlock: data.replacerBlock,
					position: data.position,
				});
			}
			if (data.type === 'drop') {
				await this.$store.dispatch('block/dropInBlock', {
					parentBlock: this.currentBlock,
					currentBlock: data.currentBlock,
					replacerBlock: data.replacerBlock,
					position: data.position,
				});
			}
		},
		async addBlock(data, position) {
			if (!position) {
				position = this.dropcursor.blockPosition;
				if (this.dropcursor.position === 'bottom') {
					position += 1;
				}
			}
			this.dropcursor.el = null;
			let type = 'text';
			let content = {
				html: data.payload.html,
			};
			let html = $.parseHTML(data.payload.html, document);
			let el = $(html);
			// if (el[0] && el[0].nodeName === 'IMG') {
			// 	type = 'image';
			// 	content = {
			// 		url: el[0].src,
			// 	};
			// }
			let blockData = {
				position: position,
				block: {
					parent: this.currentBlock._id,
					type: type,
					archive: false,
					content: content,
					source: {
						url: data.url,
					},
				},
			};
			//this.$store.dispatch('block/addTextBlockToParent', blockData);
			//let res = await this.$store.dispatch('block/createBlock', blockData);
		},
		onRemove: function () {
			if (this.selection) {
				let selection = this.selection;
				this.$store.dispatch('dashboard/unsetSelection');
				// minor delay so the selected styles get removed before animation
				setTimeout(() => {
					this.$store.dispatch('block/removeBlocksWrapper', {
						blocksArray: selection,
						parentBlock: this.currentBlock,
					});
				}, 60);
			}
		},
		onUnselect: function () {
			if (this.selection) {
				this.$store.dispatch('dashboard/unsetSelection');
			}
		},
		onGroup: function () {
			if (this.selection && this.selection.length > 0) {
				let selection = this.selection;
				this.$store.dispatch('dashboard/unsetSelection');

				this.$store.dispatch('block/groupBlocks', {
					blocksArray: selection,
					parentBlock: this.currentBlock,
				});

				window.parent.postMessage({ type: 'grouped' }, '*');
			}
		},
		onCopy: function () {
			if (this.selection) {
				this.$store.dispatch('block/copyBlocks', this.selection);
			}
		},
		onSelectAll: function (e) {
			e.preventDefault();
			let blocksArray = this.computedBlocks.map((blockData) => {
				return blockData.block._id;
			});
			this.$store.dispatch('dashboard/setSelection', blocksArray);
		},
		changeTheme: function () {
			this.$store.dispatch('settings/updateTheme', 'pristina');
		},
		undo: function () {
			this.$store.dispatch('undo/undo');
		},
		setupHotkeys: function () {
			hotkeys.filter = () => {
				return true;
			};
			hotkeys('*', 'renderer', (e) => {
				console.log(e);
			});
			hotkeys('delete', 'renderer', this.onRemove);
			hotkeys('esc', 'renderer', this.onUnselect);
			hotkeys('ctrl+c, command+c', 'renderer', this.onCopy);
			hotkeys('ctrl+a, command+a', 'renderer', this.onSelectAll);
			hotkeys('g', 'renderer', this.onGroup);
			hotkeys('ctrl+y, command+y', 'renderer', this.changeTheme);
			hotkeys('ctrl+z, command+z', 'renderer', this.undo);
			hotkeys.setScope('renderer');
		},
		removeHotkeys: function () {
			hotkeys.deleteScope('renderer');
		},
		async addTextBlock(content) {
			let newBlock = await this.$store.dispatch('block/addTextBlockToParent', {
				position: this.computedBlocks.length,
				block: {
					parent: this.currentBlock._id,
					blocks: [],
					root: false,
					archive: false,
					type: 'text',
					content: {
						html: content,
					},
					source: {},
				},
			});
			// this doens't work atm
			this.$store.dispatch('dashboard/setFocus', newBlock._id, { root: true });
		},
		async focusOnLastBlock(id) {
			if (!id) {
				let block = this.computedBlocks[this.computedBlocks.length - 1];
				if (block && block.block) {
					id = block.block._id;
				} else {
					let block = await this.addTextBlock();
					return;
				}
			}

			if (!id) {
				return;
			}

			this.$store.dispatch('dashboard/setFocus', id);
		},
	},

	async mounted() {
		this.active = true;

		this.setupHotkeys();
	},

	beforeDestroy: function () {
		this.removeHotkeys();
	},
};
</script>

<style lang="scss">
.c-renderer {
	position: relative;
	//min-height: 300px;
	max-width: 560px;
	margin: 0 auto;

	&.dragging,
	&.moving {
		.c-block__inner {
			user-select: none;
			touch-action: none;
			pointer-events: none;
		}
	}

	.list-move {
		transition: transform 120ms cubic-bezier(0.505, 0.99, 0.98, 1);
	}

	.list-enter-active {
		transition: all 0ms linear;
		opacity: 0;
		position: absolute;
	}

	.list-leave-active {
		transition: all 0ms cubic-bezier(0.505, 0.99, 0.98, 1);
		opacity: 0;
		position: absolute;
	}

	@include media-breakpoint-down(xs) {
		max-width: 360px;
	}
}
</style>